const VARIANTS = {
  check: 'check',
  uncheck: 'uncheck',
  unknown: 'unknown',
  crown: 'crown',
  none: 'none',
  since: 'since',
}

export default { VARIANTS }
